export enum DocType {
    Financials,
    LargeHoldingChange,
    Others,
    Unknown
}

export enum DocFileType {
    Ixbrl,
    Html,
    Pdf,
    Ppt,
    Xbrl
}

export enum DocSrc {
    EDINET,
    EDGAR,
    IR,
    SET
}

export interface DocDate {
    add: Date
    access: Date
}

export interface DocIndex {
    id: string
    type: DocType
    fileType: DocFileType
    date: DocDate
    src: DocSrc //EDINET, EDGAR, IR
    srcId: string
    srcLocation: string
    meta: Meta
    lang: string
    location?: string
    locationTn?: string
}

export interface Meta {
    docType: DocType
    sym: string
    datePublish: Date
}

export interface XbrlMeta extends Meta {
    docType: DocType.Financials
    companyName: string
    dateFYEnd: Date
    datePeriodEnd: Date
    period: Period
    year: number
}

export enum Period {
    Q1 = 1,
    Q2,
    Q3,
    FY
}

export interface EdinetMeta extends XbrlMeta {
    edinetCode: string
    companyNameJpn: string
}

export interface EdgarXbrlMeta extends XbrlMeta {
    cik: string
}

/*
  {
    "ixEdinetCode":"E05717",
    "ixSym":"2163",
    "ixCompanyName":"ARTNER CO.,LTD.",
    "ixCompanyNameJpn":"株式会社アルトナー",
    "ixPeriod":"Q2",
    "ixDateFYStart":"2020-02-01",
    "ixDateFYEnd":"2021-01-31",
    "ixDatePeriodEnd":"2020-07-31",
    "docSrc":"EDINET",
    "docSrcId":"S100JOL6",
    "docFileType":"html",
    "docFileName":"2020_07_31.html",
    "docFilePath":"EDINET/2163",
    "docLang":"ja",
    "docId":"b8d28c872f4bc066ea22981d26661ad15c3589d8",
    "docLocation":"EDINET/2163/2020_07_31.html"
  }
 */

export interface Doc {
    id: string
    index: DocIndex
    content: string
    contextMap: XbrlContextMap
}

export const enumFilters = {
    formatPeriod: (x: Period) => Period[x],
    formatDocType: (x: DocType) => DocType[x],
    formatDocFileType: (x: DocFileType) => DocFileType[x],
    formatDocSrc: (x: DocSrc) => DocSrc[x]
}

//explorer
export interface XbrlContext {
    periodstart: string
    periodend: string
    instant: string
}

export interface XbrlContextMap {
    [contextRef: string]: XbrlContext
}

export interface LargeHoldingMeta extends Meta {
    docType: DocType.LargeHoldingChange
    companyName: string
    submitterName: string
    submitterNameJpn: string
    edinetCode: string
    year: number
    dateRequirePublish: Date
}